import React from 'react';
import { motion } from 'framer-motion';
import { Phone, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export function CTASection() {
  return <section className="relative py-24 bg-brand-dark overflow-hidden" data-id="element-24">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-25">
        <div className="absolute inset-0" style={{
        backgroundImage: 'radial-gradient(#A8D608 1px, transparent 1px)',
        backgroundSize: '30px 30px'
      }} data-id="element-26"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-27">
        <div className="bg-brand-darker rounded-3xl p-8 md:p-16 border border-white/10 shadow-2xl flex flex-col lg:flex-row items-center justify-between" data-id="element-28">
          <div className="lg:w-1/2 mb-10 lg:mb-0 text-center lg:text-left" data-id="element-29">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-30">
              <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-6 leading-tight" data-id="element-31">
                Need Emergency <br className="hidden md:block" data-id="element-32" />
                <span className="text-brand-green" data-id="element-33">Heating or Cooling?</span>
              </h2>
              <p className="text-gray-400 text-lg mb-8 max-w-xl mx-auto lg:mx-0" data-id="element-34">
                Our team provides industry-leading response times. We can
                specify, deliver, and commission equipment within 24 hours of
                receiving your call.
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start space-y-4 sm:space-y-0 sm:space-x-6" data-id="element-35">
                <a href="tel:08004647025" className="flex items-center text-2xl font-heading font-bold text-white hover:text-brand-green transition-colors" data-id="element-36">
                  <div className="bg-brand-green/20 p-3 rounded-full mr-4" data-id="element-37">
                    <Phone className="w-6 h-6 text-brand-green" data-id="element-38" />
                  </div>
                  0800 464 7025
                </a>
              </div>
            </motion.div>
          </div>

          <div className="lg:w-5/12 w-full" data-id="element-39">
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="bg-white rounded-2xl p-8 shadow-xl" data-id="element-40">
              <h3 className="text-2xl font-heading font-bold text-brand-dark mb-6" data-id="element-41">
                Request a Callback
              </h3>
              <form className="space-y-4" data-id="element-42">
                <div data-id="element-43">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-44">
                    Full Name
                  </label>
                  <input type="text" id="name" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-brand-green focus:border-brand-green outline-none transition-all" placeholder="John Doe" data-id="element-45" />
                </div>
                <div data-id="element-46">
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-47">
                    Phone Number
                  </label>
                  <input type="tel" id="phone" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-brand-green focus:border-brand-green outline-none transition-all" placeholder="07000 000000" data-id="element-48" />
                </div>
                <div data-id="element-49">
                  <label htmlFor="service" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-50">
                    Service Required
                  </label>
                  <select id="service" className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-brand-green focus:border-brand-green outline-none transition-all bg-white" data-id="element-51">
                    <option data-id="element-52">Boiler Hire</option>
                    <option data-id="element-53">Heater Hire</option>
                    <option data-id="element-54">Chiller Hire</option>
                    <option data-id="element-55">Cooling Hire</option>
                    <option data-id="element-56">Other</option>
                  </select>
                </div>
                <button type="button" className="w-full bg-brand-green text-brand-dark font-bold py-4 rounded-lg hover:bg-brand-dark hover:text-white transition-colors duration-300 flex justify-center items-center mt-6" data-id="element-57">
                  SUBMIT REQUEST
                  <ArrowRight className="ml-2 w-5 h-5" data-id="element-58" />
                </button>
              </form>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}